import React, { useEffect, useState } from "react";
import insicon from "../../Assets/InfoIcon.png";
import redicon from "../../Assets/redicon.png";
import ModalComponent from "./Modal.js";
import { Link } from "react-router-dom";
import defaultImage from "../../../src/Assets/fallbackimg_giftcard.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility.js";
import { getImageUrl, trackEvent } from "../Utility/Utility.js";
import ReedemType from "../Card/ReedemType.js";
import PurchaseLimitPill from "./PurchaseLimitPill.js";

const GiftCardDetailsSection = (productDetails) => {
  const [showModal, setShowModal] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [activeTab, setActiveTab] = useState("instr");
  const handleClose = () => setShowModal(false);
  const handleShow = (event, tab) => {
    event.preventDefault();
    setActiveTab(tab);
    setShowModal(true);
  };
  const [expanded, setExpanded] = useState(false);
  const translation = getTranslationData();
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    trackEvent("page_browse", {
      page_title: productDetails.productReducer?.name,
      page_url: window.location.href,
    });
  }, []);
  useEffect(() => {
    if (showModal) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [showModal]);

  const description = productDetails?.productReducer?.description || "";
  const strippedDescription = description.replace(/<[^>]+>/g, "");
  const truncationLength = isMobileView ? 80 : 180;
  const isLongDescription = strippedDescription.length > truncationLength;

  return (
    <section className="bg-white pb-0Mob mt-3">
      <div className="container big-rr mb-2">
        {showModal && (
          <ModalComponent
            productDetails={productDetails}
            show={showModal}
            modalClass={"termsModal"}
            handleClose={handleClose}
            activeTab={activeTab}
          />
        )}
        <div className="row justify-content-center p-2">
          <div className="col-lg-4 plusminus mb-2">
            <div className="img-cart text-center">

              <img
                className="w-100 h-gift gift_card_image_radius"
                style={{ width: "410px", height: "268px" }}
                src={getImageUrl(productDetails?.productReducer?.mobile) || defaultImage}
                alt="Coupon"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImage;
                }}
              />
            </div>
          </div>
          <div className="col-lg-8 mt-2 pl-25">
            <div
              id="carouselBrandControls"
              className="carousel slide"
              data-bs-ride="false"
              data-bs-touch="false"
            >
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div className="mb-3">
                    <h4 className="dis-mr-2 fnt-bold procardname">
                      {productDetails.productReducer?.name}
                    </h4>
                    <div className="row">
                      <div className="col-8">
                        <span className="pro-discount">
                          {productDetails?.productReducer?.customerDiscount !==
                            0 &&
                            `${translation.discount_flat} ${productDetails?.productReducer?.customerDiscount}%`}
                        </span>

                        <ReedemType
                          status={
                            productDetails?.productReducer?.redeemableType || ""
                          }
                        />
                      </div>
                      <div className="col-4 ">
                        <PurchaseLimitPill />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="fs-14 pt-md-0">
                      {expanded ? (
                        <div
                          className="pro-discrip description-html"
                          dangerouslySetInnerHTML={{
                            __html: description,
                          }}
                        ></div>
                      ) : (
                        <p
                          className="pro-discrip"
                          dangerouslySetInnerHTML={{
                            __html: `${description.substring(
                              0,
                              truncationLength
                            )}${isLongDescription ? "..." : ""}`,
                          }}
                        ></p>
                      )}
                      {!expanded && isLongDescription && (
                        <span className="show-more" onClick={toggleExpanded}>
                          {translation?.showMore}
                        </span>
                      )}
                      {expanded && (
                        <span className="show-less" onClick={toggleExpanded}>
                          {translation?.showLess}
                        </span>
                      )}
                    </div>
                    <div className="d-grid gap-2 imp-btns d-flex justify-content-start mt-4">
                      <Link
                        onClick={(e) => handleShow(e, "instr")}
                        className="de-counterins"
                      >
                        {translation?.importantInstructions}
                      </Link>

                      <Link
                        onClick={(e) => handleShow(e, "redeem")}
                        className="de-counterins"
                      >
                        {translation?.how_to_use}
                      </Link>
                    </div>
                    <div className="text-center">
                      <Link
                        className="tnc-link"
                        onClick={(e) => handleShow(e, "terms")}
                      >
                        {translation?.terms_condition}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GiftCardDetailsSection;
